import { render, staticRenderFns } from "./mis-pedidos.vue?vue&type=template&id=6f4b2bf6&"
import script from "./mis-pedidos.vue?vue&type=script&lang=js&"
export * from "./mis-pedidos.vue?vue&type=script&lang=js&"
import style0 from "./mis-pedidos.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports